<div class="container">
  <h3 mat-dialog-title>Add Dependant</h3>

  <form class="mat-dialog-content" (ngSubmit)="submit" #formControl="ngForm">

    <div class="form">
      <mat-form-field color="accent">
        <select matNativeControl required placeholder="Dependant" name="dependant" [(ngModel)]="employeeDependent.dependant">
          <option value="spouse">Spouse</option>
          <option value="child">Child</option>
        </select>
        <mat-error *ngIf="formControl.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
    </div>

    <!--Textarea for demo purposes-->
    <div class="form">
      <mat-form-field color="accent">
        <input matInput #input class="form-control" placeholder="First Name" [(ngModel)]="employeeDependent.firstName"
          name="firstName" required>
        <mat-error *ngIf="formControl.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
    </div>

    <!--Contains mat-hint for characters count and has maxLengt set-->
    <div class="form">
      <mat-form-field color="accent">
        <input matInput #inputstate class="form-control" placeholder="Last Name" [(ngModel)]="employeeDependent.lastName"
          name="lastName" required>
        <mat-error *ngIf="formControl.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
    </div>

    <div class="form">
      <mat-form-field color="accent">
        <select matNativeControl required placeholder="Gender" name="Gender" [(ngModel)]="employeeDependent.sex">
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
      </mat-form-field>
    </div>

    <div class="form">
      <mat-form-field color="accent">
        <mat-label>Date of Birth *</mat-label>
        <input matInput [matDatepicker]="dob" name="dob" [(ngModel)]="employeeDependent.dob" [max]="dobFilter">
        <mat-datepicker-toggle matSuffix [for]="dob" name="dob" ></mat-datepicker-toggle>
        <mat-datepicker #dob></mat-datepicker>
      </mat-form-field>
    </div>


    <div mat-dialog-actions>
      <button mat-button [disabled]="!formControl.valid" [mat-dialog-close]="1" (click)="confirmAdd()">Save</button>
      <button mat-button (click)="onNoClick()" tabindex="-1">Cancel</button>
    </div>
  </form>
</div>